/**
 * 微信公众号网页授权
 */
export const AUTH_REDIRECT = '/h5/redirect' // 微信公众号网页授权入口

// 跳转微信授权，授权成功后回到当前页
export const redirectToAuth = () => {
  location.href = `${AUTH_REDIRECT}?url=${encodeURIComponent(location.href)}&scope=snsapi_userinfo`
}
